/**
 * In-game indicator component.
 * Shows a pulsing icon with game name when user has an active game session.
 * Clicking returns user to their active game.
 */

import type { ActiveSession } from "../types/game";

interface InGameIndicatorProps {
  session: ActiveSession;
  onClick: () => void;
}

// Map game IDs to display names
const GAME_NAMES: Record<string, string> = {
  "terrible-psychiatrist": "Psychiatrist",
  caw: "Caw",
  "peer-review": "Peer Review",
  "sick-day": "Sick Day",
  "debate-club": "Debate Club",
  "hot-potato-heist": "Heist",
  "liars-hand": "Liars Hand",
  bluffalo: "Bluffalo",
  codebreakers: "Codebreakers",
  "hive-mind": "Hive Mind",
};

export function InGameIndicator({ session, onClick }: InGameIndicatorProps) {
  const gameName = GAME_NAMES[session.game_id] || session.game_id || "Game";

  return (
    <button
      onClick={onClick}
      className="relative flex items-center gap-2 px-3 py-1.5 rounded-lg bg-green-600 hover:bg-green-500 border-2 border-black transition-colors cursor-pointer text-white text-sm font-semibold"
      title={`Return to ${gameName} (${session.room_code})`}
      aria-label={`Return to ${gameName} in room ${session.room_code}`}
    >
      <span role="img" aria-hidden="true">
        🎮
      </span>
      <span className="whitespace-nowrap">{gameName}</span>
      {/* Pulsing indicator */}
      <span className="absolute -top-1 -right-1 h-3 w-3 bg-green-400 rounded-full animate-pulse border border-black" />
    </button>
  );
}
